<template>
  <div class="v-content">
    <!-- 轮播 -->
    <div class="lunbo" v-if="$route.meta.banner">
      <a-carousel dotsClass="dot" autoplay>
        <div v-for="(item,i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://'+item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 视频列表 -->
    <div class="video main-center">
      <div class="info" @click="showModal(i)" v-for="(item,i) in videoList" :key="i" :style="{'margin-right':(i+1==videoList.length)&&((i-1)%3==0)?'calc(34.4%)':''}">
        <div class="video_info">
          <img :src="'http://'+item.head_image_file" v-if="$store.state.langStates=='zh'">
          <img :src="'http://'+item.head_image_file_en" v-else>
          <div class="play"><a-icon type="play-circle" style="color: #fff;font-size: 50px;"/></div>
        </div>
        <div class="main-font18" v-if="$store.state.langStates=='zh'">{{item.name}}</div>
        <div class="main-font18" v-else>{{item.name_en}}</div>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination size="small" :total="videoInfo.total" :show-total="total => `${$t('title.total')} ${videoInfo.last_page} ${$t('title.pages')}`" :defaultPageSize="6" @change="onChange"/>
      </div>
    </div>
    <!-- 视频弹窗 -->
    <a-modal v-model="visible" :closable="true" :footer="null" width="80%" :destroyOnClose="true" wrapClassName="video">
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
    </a-modal>
  </div>
</template>

<script>
  export default {
    name: 'BusImg',
    data() {
      return {
        banner:'',
        videoList:[],
        videoInfo:{
									last_page:0
								},
        visible: false,
        // 视频播放
        playerOptions: {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",
            src: '' //url地址
            // src: "" //url地址
          }],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true //全屏按钮
          }
        }
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    watch: {
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/download') {
            that.init(that.$store.state.langStates,1)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val,1)
      }
    },
    methods: {
      init(lang,p){
        this.$api.dongjuapi.videos(lang,{
          limit:6,
          page:p
        }).then(res=>{
          this.videoInfo = res.data.data
          this.videoList = res.data.data.data
        }).catch(err=>{

        })
        // 获取banner
        this.$api.dongjuapi.banner({
          type:'video'
        }).then(res=>{
          if(res.data.code==200){
            this.banner = res.data.data
          }
        })
      },
      showModal(i) {
        this.visible = true;
        this.playerOptions.autoplay = true
        if(this.$store.state.langStates=='zh'){
          this.playerOptions.sources[0].src = 'http://' + this.videoList[i].video_file
        }else if(this.$store.state.langStates=='en'){
          this.playerOptions.sources[0].src = 'http://' + this.videoList[i].video_file_en
        }
      },
      onChange(current){
        this.init(this.$store.state.langStates,current)
      }
    }
  }
</script>

<style lang="less">
  .v-content{
    .video {
      padding: 80px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .info {
        width: 31.5%;
        height: 346px;
        background: #fff;
        border-radius: 2px;
        // float: left;
        margin-bottom: 40px;

        .video_info {
          width: 100%;
          height: 266px;
          position: relative;
          img{
            width: 100%;
            height: 100%;
            border-radius: 2px 2px 0px 0px;
          }
          .play{
            position: absolute;
            width: 50px;
            height: 50px;
            top: 108px;
            left: 175px;
          }
        }

        .main-font18 {
          width: 100%;
          height: 80px;
          line-height: 80px;
          padding-left: 20px;
        }
      }
    }
  }
  .video{
    .ant-modal-close-x{
      width: 100px;
      height: 100px;
      line-height: 100px;
      font-size: 35px;
      color: #fff;
    }
  }
  #components-pagination-demo-mini{
    text-align: right;
    margin-top: 40px;
    margin-bottom: 40px;
    .ant-pagination-item-active{
      background: #746CAF;
      color: #fff;
      a{
        color: #fff;
      }
    }
  }
</style>
